import {
    IKnockoutComponent,
    ITableColumn,
    TBaseOrObservableOrFunctionArrayType,
    TBaseOrObservableType
} from "../../index";
import {IAllCheckbox} from "../search/th-checkbox";
import {IItemCheckbox} from "../search/td-checkbox";

interface ISortableTableParamsBase<T extends any = any> {
    TABLE: TBaseOrObservableOrFunctionArrayType<ITableColumn<T>>
    translate?: (key: keyof T) => TBaseOrObservableType<string>
    allCheckbox?: IAllCheckbox<T>
    getItemCheckbox?: (o: T) => IItemCheckbox
}

interface ISortableTableParams<T extends any = any, K = keyof T, V = T[keyof T]> extends ISortableTableParamsBase<T> {
    asc?: KnockoutObservable<boolean>
    data: T[] | KnockoutObservableArray<T> | KnockoutComputed<T[]>
    dataPage?: () => T[]
    getCellContent?: (key: K, val: V, item: T) => string
    getCellSortValue?: (key: K, val: V, item: T) => any
    getCellText?: (key: K, val: V, item: T) => string
    getCellTitle?: (key: K, val: V, item: T) => string
    getHeaderTitle?: (data: any) => string
    getNavComponent?: () => IKnockoutComponent
    getNavContent?: () => string
    isDisabled?: (item: T) => boolean
    isSelected?: (item: T) => boolean
    onRowClick?: (row: T) => boolean
    onRowKeyUp?: (row: T) => void
    pagenr?: KnockoutObservable<number>
    route?: string
    searchkey?: KnockoutObservable<string>
    showAll?: boolean
    sortcol?: KnockoutObservable<K>
}

interface ISortableTableHeadingParams<T extends any = any> extends ISortableTableParamsBase<T> {
    asc: KnockoutObservable<boolean>
    getHeaderTitle: (data: any) => string
    isSortableColumn: (col: ITableColumn) => boolean
    sortcol: KnockoutObservable<string>
}

interface ISortButtonParams {
    sortcol: KnockoutObservable<string>
    key: string
    asc: KnockoutObservable<boolean>
    onSortClick?: (key: string) => void
}

interface ISelectedListParams<T> {
    tableParams: ISortableTableParams<T>
    checkedKey: keyof T
    selectedObjects: KnockoutObservableArray<T>
    showHelp: boolean
    numObjectsText: (num: number) => string
}
